import Section from '@components/elements/Section'
import Title from '@components/elements/Title'
import React from 'react'
import styled from 'styled-components'

interface ItemsProps {
  title: string
  text: string
  icon: string
}

interface ItemProps {
  dark?: boolean
  dots?: boolean
}

const Item = styled.div<ItemProps>`
  display: flex;
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    margin: 0 0 5px;
  }
  i {
    font-size: 2rem;
    line-height: 1;
    margin: 5px 10px 0 0;
  }
`

const LeistungenShort = ({
  dark = false,
  item,
  titleSize
}: {
  dark?: boolean
  item: {
    title: string
    image: {
      src: string
      alt: string
    }
    items: ItemsProps[]
  }
  titleSize: number
}) => {
  return (
    <Section dark={dark}>
      <div className="container">
        <Title
          title={item.title}
          dark={false}
          titleSize={titleSize}
          fontSize="2.3rem"
        />
        <div className="columns">
          <div className="column is-10 is-offset-1 is-offset-0-mobil">
            <div className="columns is-multiline">
              {item.items.map((item, i) => (
                <Item className="column is-half" dark={dark} key={i}>
                  <i className="material-icons">{item.icon}</i>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </Item>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default LeistungenShort
